/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["iframe[_ngcontent-%COMP%]{width:100%;max-width:100%}"];
export { styles as styles };
